module.exports = __webpack_public_path__ + "img/badge-highest-revenue-keyvue-green.5c353526.png";